import {
  ForgotPasswordValues,
  SigninFormValues,
  SignupFormValues,
} from "./types";

/** Shared password rules (signup): min 6 chars, ≥1 uppercase. */
export const MIN_PASSWORD_LENGTH = 6;

export const isValidEmail = (email: string): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

export const validatePassword = (password: string): string | null => {
  if (!password.trim()) return "Password is required.";
  if (password.length < MIN_PASSWORD_LENGTH) {
    return `Password must be at least ${MIN_PASSWORD_LENGTH} characters.`;
  }
  if (!/[A-Z]/.test(password)) {
    return "Password must contain at least one uppercase letter.";
  }
  return null;
};

export const validateSignup = (values: SignupFormValues): string | null => {
  if (!values.firstName.trim()) return "First name is required.";
  if (!values.lastName.trim()) return "Last name is required.";
  if (!values.username.trim()) return "Username is required.";
  if (!values.email.trim()) return "Email is required.";
  if (!isValidEmail(values.email)) return "Please enter a valid email.";
  const passwordError = validatePassword(values.password);
  if (passwordError) return passwordError;
  if (!values.confirmPassword.trim()) return "Confirm password is required.";
  if (values.password !== values.confirmPassword) return "Passwords do not match.";
  // if (!values.acceptTerms) return "Please accept terms and privacy policy.";
  return null;
};

export const validateSignin = (values: SigninFormValues): string | null => {
  if (!values.email.trim()) return "Email is required.";
  if (!isValidEmail(values.email)) return "Please enter a valid email.";
  if (!values.password.trim()) return "Password is required.";
  return null;
};

export const validateForgotPassword = (
  values: ForgotPasswordValues
): string | null => {
  if (!values.email.trim()) return "Email is required.";
  if (!isValidEmail(values.email)) return "Please enter a valid email.";
  return null;
};
